/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type RouteAnalytics_GetOrganizerCuidQueryVariables = {
    organizerSlug: string;
};
export type RouteAnalytics_GetOrganizerCuidQueryResponse = {
    readonly organizer_connection: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly cuid: string;
            };
        }>;
    };
};
export type RouteAnalytics_GetOrganizerCuidQuery = {
    readonly response: RouteAnalytics_GetOrganizerCuidQueryResponse;
    readonly variables: RouteAnalytics_GetOrganizerCuidQueryVariables;
};



/*
query RouteAnalytics_GetOrganizerCuidQuery(
  $organizerSlug: String!
) {
  organizer_connection(where: {slug: {_eq: $organizerSlug}}) {
    edges {
      node {
        cuid
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "organizerSlug"
        } as any
    ], v1 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "_eq",
                            "variableName": "organizerSlug"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "slug"
                }
            ],
            "kind": "ObjectValue",
            "name": "where"
        } as any
    ], v2 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cuid",
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "RouteAnalytics_GetOrganizerCuidQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "organizerConnection",
                    "kind": "LinkedField",
                    "name": "organizer_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "organizerEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "organizer",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "query_root",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "RouteAnalytics_GetOrganizerCuidQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "organizerConnection",
                    "kind": "LinkedField",
                    "name": "organizer_connection",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "organizerEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "organizer",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "id",
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "b9fd490129007f5a11d805b89ad1d1aa",
            "id": null,
            "metadata": {},
            "name": "RouteAnalytics_GetOrganizerCuidQuery",
            "operationKind": "query",
            "text": "query RouteAnalytics_GetOrganizerCuidQuery(\n  $organizerSlug: String!\n) {\n  organizer_connection(where: {slug: {_eq: $organizerSlug}}) {\n    edges {\n      node {\n        cuid\n        id\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = 'a4a90bd0cd03b1c770de9853bfa941c4';
export default node;
